import { ROLES_LIST } from '@/js/constants';
export default [{
  icon: 'icon-summary',
  name: 'overview',
  key: 'menu.dataops.overview',
  link: '/dataops/overview',
  href: {
    name: 'overview'
  },
  roles: [ROLES_LIST.DATAOPS_USER]
}, {
  icon: 'mdi-laptop',
  name: 'New orchestration',
  key: 'menu.dataops.orchestration',
  link: '/dataops/orchestration',
  href: {
    name: 'orchestration'
  },
  roles: [ROLES_LIST.DATAOPS_USER]
}, {
  icon: 'mdi-calendar-clock',
  name: 'executions_history',
  key: 'menu.dataops.executions_history',
  link: '/dataops/executions_history',
  href: {
    name: 'executions_history'
  },
  roles: [ROLES_LIST.DATAOPS_USER]
}, {
  name: 'Monitoring & Billing',
  key: 'menu.dp.monitoring_billing',
  icon: 'mdi-cash-multiple',
  subname: '',
  roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.DATAOPS_USER, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD],
  subItems: [{
    name: 'Reportes',
    key: 'menu.dp.monitoring_billing_reports',
    subname: '',
    checkDomain: false,
    href: {
      name: 'MonitoringReports'
    },
    link: '/MonitoringReports',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.DATAOPS_USER, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD]
  }, {
    name: 'Maintenance',
    key: 'menu.dp.monitoring_billing_maintenance',
    subname: '',
    checkDomain: false,
    href: {
      name: 'MonitoringMaintenance'
    },
    link: '/MonitoringMaintenance',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.DATAOPS_USER, ROLES_LIST.SECURITY_TECHNICAL_DATASTEWARD]
  }]
}];